/*
  the collation postgres uses for sorting is now a lot more
  faithful to that which is returned by localeCompare in en_US locale
  (but still not perfect)
*/
const SORT_LOCALE: Intl.LocalesArgument = 'en-US'

export const toLower = (value: string) => value.toLocaleLowerCase(SORT_LOCALE)

export const sortAlphaLower = (a: string, b: string) =>
  a.localeCompare(b, SORT_LOCALE, { sensitivity: 'base' })
